import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AnnotationConstraints, ConnectorModel, DiagramComponent, DiagramModule, DiagramTools, DiagramTooltipModel, IExportOptions, ImageModel, MarginModel, NodeConstraints, NodeModel, PaletteModel, SelectorConstraints, SelectorModel, SnapConstraints, SnapSettingsModel, ZoomOptions } from '@syncfusion/ej2-angular-diagrams';
import printJS from 'print-js';
import { forkJoin, Subscription } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { LayoutService } from 'src/app/services/layout.service';
import { MarketInfoService } from 'src/app/services/marketInfo.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ops-view-layout',
  standalone: true,
  imports: [TopBarComponent, SYNCFUSION_MODULES, ANGULAR_MODULES,
    OperationsComponent, DiagramModule, WordReplacePipe],
  templateUrl: './ops-view-layout.html',
  styleUrl: './ops-view-layout.scss'
})
export class OpsViewLayout {
  public tooltip?: DiagramTooltipModel;
  constructor(private layoutService: LayoutService,
    private formbuilder: FormBuilder,
    private operationRentalService: OperationRentalService,
    private customCurrency: customCurrencyPipe,
    private datePipe: DatePipe,
    private generalService: GeneralService,
    private marketInfoService: MarketInfoService,
    private wordReplacePipe: WordReplacePipe,
    private router: Router) {
    this.selectedItems = {
      constraints: SelectorConstraints.All &
        ~(SelectorConstraints.ResizeAll | SelectorConstraints.Rotate)
    };
    const dayControls: { [key: string]: any } = {};
    this.days.forEach(day => {
      dayControls[day] = [{ value: false, disabled: true }];
    });
    this.symbolMargin = { left: 15, right: 15, top: 15, bottom: 15 };
    this.layoutForm = this.formbuilder.group({
      colorCodingOptions: ['0'],
      rentalType: ['1'],
      fromDate: [null],
      toDate: [null],
      layoutParts: [null, Validators.required],
      marketDays: this.formbuilder.group(dayControls),
      layoutDiagramFilter: this.formbuilder.group({
        searchBooth: ['']
      })
    });
  }
  layoutForm: FormGroup;
  @ViewChild('diagram', { static: false }) public diagram: DiagramComponent;
  selectedMarketDays = [];
  displayLayout = false;
  public options: IExportOptions;
  disableViewButton = true;
  images = [];
  parts = [];
  public palettes?: PaletteModel[];
  connectors: ConnectorModel[];
  selectedItems: SelectorModel;
  symbolMargin: MarginModel;
  noboothSelected = true;
  blinkingNode: string = '';
  allBooths = [];
  selectedDays = [];
  layoutImages = [];
  defaultZoomFactor = 0;
  blinkInterval: any;
  public snapSettings: SnapSettingsModel = {
    constraints: SnapConstraints.None,
  };
  tool: DiagramTools;
  boothShapes;
  fontName;
  fontStyle = [];
  rentalStartDates = [];
  BoothNumber;
  BoothType;
  public loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  isCollapsed: boolean = true;
  days: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  dayMapping = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  daily = false;
  combinedMonthly = false;
  combinedWeekly = false;
  quickDaily = false;
  event = false;
  onload = false;
  viewRight: boolean;
  viewRightFalseMessage;
  isDropdownOpen = false;
  categoryLegend = [];
  selectedPartName = "";
  defaultRentalType: string = '4';
  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      if (this.layoutForm.controls['layoutDiagramFilter'].value['searchBooth']) {
        this.searchNodes();
      }
    }
  }

  @HostListener('document:click', ['$event'])
  clickOutsideDropdown(event: MouseEvent): void {
    const legendDropDown = document.querySelector('.legendDropDown');
    const dropdownElement = document.querySelector('.custom-dropdown');
    if (legendDropDown) {
      if (!legendDropDown.contains(event.target as Node) && !dropdownElement.contains(event.target as Node) && ((document.querySelector('.legendDropDown') as HTMLElement).classList.contains('open'))) {
        this.isDropdownOpen = false;
      }
    }
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  closeCategoryLegend() {
    this.isDropdownOpen = false;
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  toggleDropdown() {
    if (!this.isDropdownOpen)
      (document.querySelector('.legendDropDown') as HTMLElement).classList.add('open');
    else
      (document.querySelector('.legendDropDown') as HTMLElement).classList.remove('open');
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  ngOnInit(): void {
    this.layoutForm.get('toDate').setValue(new Date());
    this.layoutForm.get('fromDate').setValue(new Date());
    this.getParts();
    this.getRentalType();
    this.getProductCategories();    
    this.getListOfValuesData();
    this.getDefaultZoomFactor();
    this.getImages();
  }

  getProductCategories() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.operationRentalService.getProductCategories().subscribe((res: any) => {
      if (res) {
        res.map((el, i) => {
          const ob = {
            categoryName: el.CategoryDescription,
            color: this.convertColor(el.Color)
          }
          this.categoryLegend.push(JSON.parse(JSON.stringify(ob)));
        })
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getListOfValuesData() {
    this.loaderIcon = Promise.resolve(true);
    forkJoin({
      boothShapes: this.generalService.getListOfValuesByType(1),
      fontName: this.generalService.getListOfValuesByType(2),
      fontStyle: this.generalService.getListOfValuesByType(3)
    }).subscribe(async ({ boothShapes, fontName, fontStyle }) => {
      this.boothShapes = boothShapes;
      this.fontName = fontName;
      this.fontStyle = fontStyle;
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getDefaultZoomFactor() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.layoutService.getLayoutFonts().subscribe((res: any) => {
      if (res) {
        this.defaultZoomFactor = res.DefaultZoomFactor ?? 0
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getRentalType() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.marketInfoService.getRentalType().subscribe((res: any) => {
      const rentalTypes = res.split(',');
      rentalTypes.map((el, i) => {
        switch (el) {
          case '1': this.daily = true;
            break;
          case '4': this.combinedMonthly = true;
            break;
          case '5': this.combinedWeekly = true;
            break;
        }
        this.getRentalPaymentSettings();
      });
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  private isCheckingMarketDays = false;
  checkForMarketDays() {
    try {
      const rentalTypeSelected = this.layoutForm.value['rentalType'];
      this.rentalStartDates = [];
      this.disableViewButton = true;

      // Disable all days first
      this.disableAllDays();
      this.resetAllDays(false);

      let fromDate = new Date();

      while (fromDate != null) {
        for (const el of this.selectedMarketDays) {
          const selectedDayOfWeek = el - 1;
          if (fromDate.getDay() === selectedDayOfWeek) {
            this.onload = true;
            this.layoutForm.get('fromDate').setValue(new Date(fromDate), { emitEvent: false });
            this.layoutForm.get('toDate').setValue(new Date(fromDate), { emitEvent: false });

            fromDate = null;
            break;
          }
        }
        if (fromDate) fromDate.setDate(fromDate.getDate() + 1);
      }

      this.disableViewButton = false;

      if (['1', '4', '5'].includes(rentalTypeSelected)) {
        const marketDate = new Date(this.layoutForm.value['fromDate']);
        const fullDayName = this.datePipe.transform(marketDate, 'EEEE'); // e.g. "Sunday"
        const shortDayName = fullDayName ? fullDayName.substring(0, 3) : ''; // e.g. "Sun"
        const dayCtrl = this.layoutForm.get(['marketDays', shortDayName]);
        if (dayCtrl) {
          dayCtrl.enable({ emitEvent: false });
          dayCtrl.setValue(true, { emitEvent: false });
        }
      }
    } finally {
      this.isCheckingMarketDays = false;
    }
  }

  checkSelectedMarketDays() {
    this.disableAllDays();
    if (!this.onload) {
      const marketDaysGroup = this.layoutForm.get('marketDays') as FormGroup;
      const fromDate = new Date(this.layoutForm.value['fromDate'].getFullYear(), this.layoutForm.value['fromDate'].getMonth(), this.layoutForm.value['fromDate'].getDate());
      const toDate = this.layoutForm.value['rentalType'] !== '1' ? new Date(this.layoutForm.value['toDate'].getFullYear(), this.layoutForm.value['toDate'].getMonth(), this.layoutForm.value['toDate'].getDate()) : null;

      // Set toDate equal to fromDate if it is greater
      if (toDate && new Date(fromDate) > new Date(toDate)) {
        // this.toastr.warning($localize`From Date cannot be greater than To Date`, $localize`Error`, this.toasterConfig);
        this.layoutForm.get('toDate').setValue(new Date(fromDate), { emitEvent: false });
        return false;
      }

      this.rentalStartDates = [];
      switch (this.layoutForm.value['rentalType']) {
        case '1':
          if (!this.daily) break;
          this.disableAllDays();
          this.resetAllDays(false);
          const selectedDayOfWeek = fromDate.getDay();
          if (this.selectedMarketDays.includes(selectedDayOfWeek + 1)) {
            const fullDayName = this.datePipe.transform(fromDate, 'EEEE');
            const shortDayName = fullDayName ? fullDayName.substring(0, 3) : '';
            const dayFormControl = marketDaysGroup.get(shortDayName);
            if (dayFormControl) {
              dayFormControl.enable();
              dayFormControl.setValue(true, { emitEvent: false });
            }
            this.rentalStartDates.push({
              startDate: this.datePipe.transform(fromDate, 'MMM d, y')
            });
          }

          if (this.rentalStartDates.length === 0) {
            this.disableViewButton = true;
            Swal.fire({
              title: $localize`Warning`,
              text: $localize`Selected day is not a market day`,
              icon: "warning",
              confirmButtonText: $localize`Ok`,
            });
          }
          else {
            this.disableViewButton = false;
          }
          break;

        case '4':
          this.disableAllDays();
          this.resetAllDays(false);

          while (new Date(fromDate) <= new Date(toDate)) {
            const selectedDayOfWeek = fromDate.getDay();
            if (this.selectedMarketDays.includes(selectedDayOfWeek + 1)) {
              const fullDayName = this.datePipe.transform(fromDate, 'EEEE');
              const shortDayName = fullDayName ? fullDayName.substring(0, 3) : '';
              const dayFormControl = marketDaysGroup.get(shortDayName);
              if (dayFormControl) {
                dayFormControl.enable();
                dayFormControl.setValue(true, { emitEvent: false });
              }
              this.rentalStartDates.push({
                startDate: this.datePipe.transform(fromDate, 'MMM d, y')
              });
            }
            fromDate.setDate(fromDate.getDate() + 1);
          }

          if (this.rentalStartDates.length === 0) {
            this.disableViewButton = true;
            Swal.fire({
              title: $localize`Warning`,
              text: $localize`No market days exist for selected range of dates`,
              icon: "warning",
              confirmButtonText: $localize`Ok`,
            });
          } else {
            this.disableViewButton = false;
          }
          break;
        case '5':
          this.disableAllDays();
          this.resetAllDays(false);

          while (fromDate <= toDate) {
            const selectedDayOfWeek = fromDate.getDay();
            if (this.selectedMarketDays.includes(selectedDayOfWeek + 1)) {
              const fullDayName = this.datePipe.transform(fromDate, 'EEEE');
              const shortDayName = fullDayName ? fullDayName.substring(0, 3) : '';
              const dayFormControl = marketDaysGroup.get(shortDayName);
              if (dayFormControl) {
                dayFormControl.enable();
                dayFormControl.setValue(true, { emitEvent: false });
              }
              this.rentalStartDates.push({
                startDate: this.datePipe.transform(fromDate, 'MMM d, y')
              });
            }
            fromDate.setDate(fromDate.getDate() + 1);
          }

          if (this.rentalStartDates.length === 0) {
            this.disableViewButton = true;
            Swal.fire({
              title: $localize`Warning`,
              text: $localize`No market days exist for selected range of dates`,
              icon: "warning",
              confirmButtonText: $localize`Ok`,
            });
          } else {
            this.disableViewButton = false;
          }
          break;
        default:
          break;
      }
    }
    else
      this.onload = false;
  }

  disableAllDays() {
    const marketDays = this.layoutForm.get('marketDays') as FormGroup;
    Object.keys(marketDays.controls).forEach(day => {
      marketDays.get(day)?.disable();
    });
  }

  resetAllDays(val) {
    const marketDays = this.layoutForm.get('marketDays') as FormGroup;
    Object.keys(marketDays.controls).forEach(day => {
      marketDays.get(day)?.setValue(val, { emitEvent: false });
    });
  }

  enableAllDays() {
    const marketDays = this.layoutForm.get('marketDays') as FormGroup;
    Object.keys(marketDays.controls).forEach(day => {
      marketDays.get(day)?.enable();
    });
  }

  getMarketDaysSettings() {
    this.marketInfoService.getMarketDaysSettings().subscribe((response) => {
      if (response) {
        this.selectedMarketDays = [];
        this.dayMapping.forEach((dayName, index) => {
          if (response[dayName]) {
            this.selectedMarketDays.push(index + 1); // +1 because you want Sunday=1
          }
        });
        this.checkForMarketDays();
      }
    }, (err) => {
    });
  }

  checkMarketDay(dayName) {
    const marketDays = this.layoutForm.get('marketDays') as FormGroup;
    if (marketDays.get(dayName)) {
      marketDays.get(dayName)?.setValue(true);
    }
  }

  getRentalPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.operationRentalService.getRentalSettings().subscribe((res: any) => {
      if (res) {
        // this.defaultRentalType = res.DefaultRentalType;
        this.layoutForm.get('rentalType').setValue(this.defaultRentalType.toString());
        if (res.DisplayDefaultPart) {
          this.layoutForm.get('layoutParts').setValue(res.DefaultPartId);
        }
        this.getMarketDaysSettings();
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  cancelLayout(): void {
    this.router.navigate(['/dashboard']);
  }

  viewLayout() {
    if (this.layoutForm.invalid) {
      this.layoutForm.markAllAsTouched();
      return;
    }
    var rentalTypeSelected = this.layoutForm.value['rentalType'];
    const marketDaysGroup = this.layoutForm.get('marketDays') as FormGroup;
    this.rentalStartDates = [];
    var selectedPartId = this.layoutForm.value['layoutParts'];
    const isValidPart = selectedPartId != null &&
      selectedPartId !== '' &&
      selectedPartId !== 'null' &&
      (this.parts ?? []).some(p => p.PartId == selectedPartId);

    if (!isValidPart) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please select a Part before viewing the layout.`,
        icon: 'warning',
        confirmButtonText: $localize`Ok`,
      });
      return;
    }

    this.selectedPartName = this.parts.filter(e => e.PartId == selectedPartId)[0]?.PartDescription;
  
    switch (rentalTypeSelected) {
      case '1':
        this.selectedDays = []
        this.displayLayout = true;
        this.selectedDays.push(new Date(this.layoutForm.value['fromDate'].getFullYear(), this.layoutForm.value['fromDate'].getMonth(), this.layoutForm.value['fromDate'].getDate()));
        var obj;
        var rentalStartDate = new Date(this.layoutForm.value['fromDate'].getFullYear(), this.layoutForm.value['fromDate'].getMonth(), this.layoutForm.value['fromDate'].getDate())
        const rentalStartDateYear = new Date(this.layoutForm.value['fromDate']).getFullYear();
        const rentalStartDateMonth = new Date(this.layoutForm.value['fromDate']).getMonth() + 1;
        const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
        var selectedMarketDays = [];
        rentalStartDate.getDay() == 0 ? selectedMarketDays.push(1) : 0;
        rentalStartDate.getDay() == 1 ? selectedMarketDays.push(2) : 0;
        rentalStartDate.getDay() == 2 ? selectedMarketDays.push(3) : 0;
        rentalStartDate.getDay() == 3 ? selectedMarketDays.push(4) : 0;
        rentalStartDate.getDay() == 4 ? selectedMarketDays.push(5) : 0;
        rentalStartDate.getDay() == 5 ? selectedMarketDays.push(6) : 0;
        rentalStartDate.getDay() == 6 ? selectedMarketDays.push(7) : 0;
        obj = {
          RentalStartDate: rentalStartDate,
          RentalEndDate: rentalStartDate,
          RentalYearMonth: rentalStartDateYearMonth,
          Monday: rentalStartDate.getDay() == 1 ? true : false,
          Tuesday: rentalStartDate.getDay() == 2 ? true : false,
          Wednesday: rentalStartDate.getDay() == 3 ? true : false,
          Thursday: rentalStartDate.getDay() == 4 ? true : false,
          Friday: rentalStartDate.getDay() == 5 ? true : false,
          Saturday: rentalStartDate.getDay() == 6 ? true : false,
          Sunday: rentalStartDate.getDay() == 0 ? true : false,
          MarketDays: selectedMarketDays.toString()
        }
        forkJoin({
          boothsList: this.operationRentalService.getAllBoothsForDailyRentalTypeLayout(this.layoutForm.value['layoutParts'], this.selectedDays),
        }).subscribe(async ({ boothsList }) => {
          let data = boothsList;
          await this.bindBoothsToLayout(data);
          await this.getBuildingForLayout();
          await this.getImagesForLayout();
          this.diagram.fitToPage();
          if (this.defaultZoomFactor) {
            let zoomOptions: ZoomOptions = {
              type: 'ZoomIn',
              zoomFactor: this.defaultZoomFactor
            };
            this.diagram.zoomTo(zoomOptions);
          }
          this.loaderIcon = Promise.resolve(false);
        });

        break;

      case '4':
      case '5':
        if (Object.values(marketDaysGroup.value).some(v => v)) {
          const rentalStartDateYear = new Date(this.layoutForm.value['fromDate']).getFullYear();
          const rentalStartDateMonth = new Date(this.layoutForm.value['fromDate']).getMonth() + 1;
          const rentalEndDateYear = new Date(this.layoutForm.value['toDate']).getFullYear();
          const rentalEndDateMonth = new Date(this.layoutForm.value['toDate']).getMonth() + 1;
          const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
          const rentalEndDateYearMonth = `${rentalEndDateYear}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;
          var marketDays = '';
          this.selectedMarketDays.forEach(element => {
            marketDays = marketDays.concat(element) + ',';
          });
          this.displayLayout = true;
          this.subscriptions.push(this.operationRentalService.getRentalSettings().subscribe((response: any) => {
            if (response) {
              var obj = {
                PartId: this.layoutForm.value['layoutParts'],
                RentalStartDate: new Date(this.layoutForm.value['fromDate'].getFullYear(), this.layoutForm.value['fromDate'].getMonth(), this.layoutForm.value['fromDate'].getDate()),
                RentalEndDate: new Date(this.layoutForm.value['toDate'].getFullYear(), this.layoutForm.value['toDate'].getMonth(), this.layoutForm.value['toDate'].getDate()),
                FirstDayOfRentalStartWeek: new Date(this.layoutForm.value['fromDate'].getFullYear(), this.layoutForm.value['fromDate'].getMonth(), this.layoutForm.value['fromDate'].getDate()),
                FirstDayOfRentalEndWeek: new Date(this.layoutForm.value['toDate'].getFullYear(), this.layoutForm.value['toDate'].getMonth(), this.layoutForm.value['toDate'].getDate()),
                RentalStartDateYearMonth: rentalStartDateYearMonth,
                RentalEndDateYearMonth: rentalEndDateYearMonth,
                MarketDays: marketDays.substring(0, marketDays.length - 1),
                WeeklyCombWeeklyReservationPeriod: response.WeeklyCombWeeklyReservationPeriod,
                MonthlyCombMonthlyReservationPeriod: response.MonthlyCombMonthlyReservationPeriod,
                RentalStartDateWeekDayNumber: new Date(this.layoutForm.value['fromDate']).getDay(),
                AllowVendorVacation: false,
                Sunday: marketDaysGroup.get("Sun").value ?? false,
                Monday: marketDaysGroup.get("Mon").value ?? false,
                Tuesday: marketDaysGroup.get("Tue").value ?? false,
                Wednesday: marketDaysGroup.get("Wed").value ?? false,
                Thursday: marketDaysGroup.get("Thu").value ?? false,
                Friday: marketDaysGroup.get("Fri").value ?? false,
                Saturday: marketDaysGroup.get("Sat").value ?? false
              }
              this.subscriptions.push(this.operationRentalService.getALLBoothsForLayoutALLRentalTypes(obj).subscribe(async (response) => {
                let data = response;
                await this.bindBoothsToLayout(data);
                await this.getBuildingForLayout();
                await this.getImagesForLayout();
                this.diagram.fitToPage();
                if (this.defaultZoomFactor) {
                  let zoomOptions: ZoomOptions = {
                    type: 'ZoomIn',
                    zoomFactor: this.defaultZoomFactor
                  };
                  this.diagram.zoomTo(zoomOptions);
                }
                this.loaderIcon = Promise.resolve(false);
              }, err => {
                this.loaderIcon = Promise.resolve(false);
              }));
            }
          }));
        }
        else {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please select atleast one market day`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });
        }
        break;
      default: break;
    }
  }

  searchNodes(): void {
    const searchValue = (this.layoutForm.controls['layoutDiagramFilter'].value['searchBooth'] ?? '').trim();
    this.stopBlinking();
    if (searchValue) {
      const matchedBooth = this.allBooths.find(item => item.BoothNumber?.toUpperCase() === searchValue.toUpperCase());
      const nodeId = 'node_' + (matchedBooth ? matchedBooth.BoothNumber : searchValue);
      const node = this.diagram.getObject(nodeId) as NodeModel;
      if (node) {
        this.blinkingNode = nodeId;
        this.startBlinking();
      } else {
        Swal.fire({
          title: $localize`Warning`,
          text: this.wordReplacePipe.transform($localize`There is no booth having this number`),
          icon: "warning",
          confirmButtonText: $localize`Ok`,
        });
      }
    }
    else {
      Swal.fire({
        title: $localize`Warning`,
        text: this.wordReplacePipe.transform($localize`Please enter the booth number to search`),
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  startBlinking(): void {
  this.stopBlinking();

  const node = this.diagram.getObject(this.blinkingNode) as NodeModel;
  if (!node) return;

  this.diagram.bringIntoView(node.wrapper.bounds);

  // Optional: select/highlight
  this.diagram.select([node]);

  // Blink
  this.blinkInterval = setInterval(() => {
    const n = this.diagram.getObject(this.blinkingNode) as NodeModel;
    if (n) {
      n.style.fill = n.style.fill === 'red' ? 'transparent' : 'red';
      this.diagram.dataBind();
    }
  }, 500);

  setTimeout(() => {
    this.stopBlinking();
    this.layoutForm.controls['layoutDiagramFilter']
      .get('searchBooth')
      .setValue('');
  }, 5000);
}

  stopBlinking(): void {
    if (this.blinkInterval) {
      clearInterval(this.blinkInterval);
      this.blinkInterval = null;

      const node = this.diagram.getObject(this.blinkingNode) as NodeModel;
      if (node) {
        const nodeId = node.id.replace("node_", "");
        const boothData = this.allBooths.find(item => item.BoothNumber == nodeId);
        if (boothData) {
            const fontColor = boothData.Status.toLowerCase() == "r" ? "#fff" : "#000";
            node.style.fill = this.convertColor(boothData.BackColor);
            node.style.strokeColor = this.convertColor(boothData.BorderColor);
            this.diagram.dataBind();
        }
      }
    }
  }

  bindBoothsToLayout(data) {
    this.loaderIcon = Promise.resolve(true);
    this.allBooths = data;
    if (data.length > 0) {
      for (const item of data) {
        var boothStatus = "Booked";
        switch (item.Status.toLowerCase()) {
          case "r": boothStatus = "Reserved"
            break;
          case "ro": boothStatus = "Reserved Only"
            break;
          case "a": boothStatus = "Available"
            break;
          case "ab": boothStatus = "Absentee Booking"
            break;
          default: boothStatus = "Booked"
            break;
        }

        if (item.Status.toLowerCase() == 'd' && item.AccountReceiptId == 0) {
          boothStatus = "Closed Out";   //Booth closeout
        }

        const fontColor = boothStatus.toLowerCase() == "reserved" ? "#fff" : "#000";
        const tooltipCaption = item.VendorId ? 'Vendor Id:' + item.MarketVendorId + ' Name: ' + item.VendorName + ' Type: ' + item.RentalType + ' Status: ' + boothStatus + ' Product: ' + item.ProductDescription + ' VendorBalance : ' + this.customCurrency.transform(((-1) * item.PriorBalance).toString()) + ' Booth Number: ' + item.BoothNumber + ' Booth Type: ' + item.BoothType + ' Booth Description: ' + item.BoothDescription : ' Booth Number: ' + item.BoothNumber + ' Booth Type: ' + item.BoothType + ' Booth Description: ' + item.BoothDescription;
        const nodeId = 'node_' + item.BoothNumber;
        const diagramNode: NodeModel = {
          id: nodeId,
          shape: {
            type: 'Basic',
            shape: this.boothShapes.filter(e => e.Id == item.ShapeId)[0]?.Name
          },
          style: {
            fill: this.convertColor(item.BackColor),
            strokeColor: this.convertColor(item.BorderColor),
            color: fontColor,
            strokeWidth: 0.5,
            fontSize: item.FontSize,
            textWrapping: 'Wrap',
            fontFamily: this.fontName.filter(e => e.Id == item.FontName)[0]?.Name
          },
          annotations:
            [{
              content: item.BoothNumber,
              style: {
                fontSize: item.FontSize,
                color: fontColor,
                fontFamily: this.fontName.filter(e => e.Id == item.FontName)[0]?.Name,
                textWrapping: 'Wrap',
                bold: this.fontStyle.filter(e => e.Id == item.FontStyle)[0]?.Name.toLowerCase().includes('bold'),
                italic: this.fontStyle.filter(e => e.Id == item.FontStyle)[0]?.Name.toLowerCase().includes('italic')
              },

              constraints: AnnotationConstraints.ReadOnly
            }],
          tooltip: {
            content: tooltipCaption,
            position: 'TopCenter',
            relativeMode: 'Object',
          },
          width: item.Width * 3,
          height: item.Length * 3,
          addInfo: {
            allowDrag: true,
            name: 'booth',
            status: item.Status
          },
          constraints: NodeConstraints.Default & ~(NodeConstraints.Drag) | NodeConstraints.Tooltip,
          offsetX: item.LeftCoordinate,
          offsetY: item.TopCoordinate,
          rotateAngle: item.RotateAngle
        };
        this.diagram.add(diagramNode);
      }
      this.loaderIcon = Promise.resolve(false);
    }
  }

  changeSearchText() {
    if (this.layoutForm.controls['layoutDiagramFilter'].value['searchBooth'] == '') {
      this.stopBlinking();
    }
  }

  closeLayoutForm() {
    this.displayLayout = false;
    this.layoutForm.controls['layoutDiagramFilter'].get('searchBooth').setValue("");
    this.stopBlinking();
  }

  convertColor(colorValue: number): string {
    if (colorValue == 255 || colorValue == 65280 || colorValue == 0)
      return '#' + colorValue.toString(16).padStart(6, '0');
    else
      return '#' + colorValue.toString(16);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  getImages() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.layoutService.getImages().subscribe((res: any) => {
      if (res) {
        this.layoutImages = res;
        let data = this.layoutImages;
        if (this.layoutImages.length > 0) {
          for (let i = 0; i < this.layoutImages.length; i++) {
            const nodeId = 'node_' + data[i].ImageId;
            let node = {
              id: nodeId, addInfo: {
                status: data[i].ImagePath, id: 'z' + data[i].ImageId, name: "image", ImageId: data[i].ImageId,
              },
              annotations: [{ content: data[i].ImageName, constraints: AnnotationConstraints.ReadOnly, offset: { x: 0.5, y: -0.07 } }],
              shape: { type: 'Image', shape: 'Image' },
              width: 50, height: 50, offsetX: 50, offsetY: 50,
            };
            if (node.shape.type === 'Image') {
              (node.shape as ImageModel).source = node.addInfo.status;
            }
            this.images.push(node);
          }

          this.palettes = [
            {
              id: 'Images',
              expanded: true,
              symbols: this.images,
              title: 'Images'
            },
          ]
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  layoutZoomInClick(event) {
    let zoomOptions: ZoomOptions = {
      type: "ZoomIn",
      zoomFactor: 0.2
    }
    if (event.detail > 0) {
      this.diagram.zoomTo(zoomOptions)
    }
  }

  getParts() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.layoutService.getParts().subscribe((res: any) => {
      if (res) {
        this.parts = res; this.layoutForm.get('layoutParts').setValue(res[0]?.PartId);
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  layoutZoomOutClick(flag = false) {
    let zoomOptions: ZoomOptions = {
      type: "ZoomOut",
      zoomFactor: 0.2
    }
    if (flag) {
      this.diagram.zoomTo(zoomOptions)
    }
  }

  async getBuildingForLayout() {
    this.loaderIcon = Promise.resolve(true);
    const res = await this.layoutService.getBuildingAreasInLayOut(this.layoutForm.value['layoutParts']).toPromise();
    let data = res;
    if (data.length > 0) {
      data.map((item) => {
        const nodeId = 'node_building' + item.BuildingId;
        const diagramNode: NodeModel = {
          id: nodeId,
          shape: {
            type: 'Basic',
            shape: this.boothShapes.filter(e => e.Id == item.ShapeId)[0]?.Name
          },
          style: {
            fill: item.BuildingBackColor != 0 ? this.convertColor(item.BuildingBackColor) : "#000",
            strokeColor: item.BuildingBackColor != 0 ? this.convertColor(item.BuildingBorderColor) : "#000",
            strokeWidth: 0.5,
            fontSize: item.BuildingFontSize,
            textWrapping: 'Wrap',
            fontFamily: this.fontName.filter(e => e.Id == item.BuildingFontNameId)[0]?.Name
          },
          annotations:
            [{
              content: item.BuildingVerticalDisplay ? this.getVerticalText(item.Caption) : item.Caption,
              style: {
                fontSize: item.BuildingFontSize,
                fontFamily: this.fontName.filter(e => e.Id == item.BuildingFontNameId)[0]?.Name,
                textWrapping: 'Wrap',
                bold: this.fontStyle.filter(e => e.Id == item.BuildingFontStyleId)[0]?.Name.toLowerCase().includes('bold'),
                italic: this.fontStyle.filter(e => e.Id == item.BuildingFontStyleId)[0]?.Name.toLowerCase().includes('italic')
              },
              constraints: AnnotationConstraints.ReadOnly
            }],
          width: item.BuildingWidth * 3,
          height: item.BuildingLength * 3,
          addInfo: {
            allowDrag: false, // Enable drag-and-drop for this shape
            id: item.BuildingId,
            name: 'building'
          },
          constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
          offsetX: item.LeftCoordinate,
          offsetY: item.TopCoordinate,
          rotateAngle: item.RotateAngle
        };
        this.diagram.add(diagramNode);
      });
    }
    this.loaderIcon = Promise.resolve(false);
  }

  getVerticalText(text: string): string {
    return text.split('').join('\n');
  }

  async getImagesForLayout() {
    this.loaderIcon = Promise.resolve(true);
    var response = await this.layoutService.getLayoutImages(this.layoutForm.value['layoutParts']).toPromise();
    if (response) {
      let data = response;
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          let node = {
            id: 'node_images' + data[i].ImagesForLayoutId,
            addInfo: {
              status: this.layoutImages.filter(e => e.ImageId == data[i].LayoutImagesId)[0]?.ImagePath,
              id: data[i].ImagesForLayoutId,
              name: "image",
              ImageId: data[i].LayoutImagesId,
            },
            style: {
              strokeWidth: 0
            },
            annotations: [
              {
                //    content: this.layoutImages.filter(e => e.ImageId == data[i].LayoutImagesId)[0].ImageName,
                constraints: AnnotationConstraints.ReadOnly,
                offset: { x: 0.05, y: -0.07 }
              }
            ],
            constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
            shape: { type: 'Image', shape: 'Image' } as ImageModel, // Type assertion to ImageModel
            width: data[i].ImageWidth * 3,
            height: data[i].ImageLength * 3,
            offsetX: data[i].ImageLeftCoordinate,
            offsetY: data[i].ImageTopCoordinate,
          };

          if ((node.shape as { type: string }).type === 'Image') {
            (node.shape as ImageModel).source = node.addInfo.status;
          }

          this.diagram.add(node);
        }
        this.loaderIcon = Promise.resolve(false);
      }
    }
    this.loaderIcon = Promise.resolve(false);
  }

  async printDiagram() {
    try {
      const rawSvg = await this.diagram.exportDiagram({
        format: 'SVG',
        mode: 'Data',
        region: 'Content',
      });

      // Convert SVGElement or string to string
      const svgString = typeof rawSvg === 'string'
        ? rawSvg
        : rawSvg?.outerHTML ?? '';

      const htmlContent = `
  <div style="text-align: center; padding: 20px; position: absolute;margin-bottom:10px">
    <h5 style="margin-botton : 10px">${this.selectedPartName}</h5>
  </div><div style="height: 40px;"></div>
  <div style="text-align: center;">
    ${svgString}
  </div>
`;

      printJS({
        printable: htmlContent,
        type: 'raw-html',
        style: `
    @media print {
      @page {
        size: A4 landscape;
        margin: 10mm;
      }

      body {
        margin: 0;
        padding: 0;
      }

      .svg-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 90vh;
        overflow: hidden;
      }

      .svg-container svg {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
      }

      h5 {
        font-size: 1em;
        margin-bottom: 10px;
        text-align: center;
      }
    }
  `,
      });
    }
    catch {
      const svgElement = await this.diagram.exportDiagram({
        format: 'SVG',
        mode: 'Data',
        region: 'Content',
      });

      // Convert DOM element to string
      const svgString = (svgElement as SVGSVGElement).outerHTML;
      const bounds = this.diagram.getDiagramBounds();
      const viewBox = `0 0 ${bounds.width} ${bounds.height}`;

      // Inject viewBox and preserveAspectRatio
      let svgWithAttrs = svgString
        .replace(
          /<svg([^>]*)(?<!viewBox=["'][^"']*["'])/,
          `<svg viewBox="${viewBox}" preserveAspectRatio="xMidYMid meet"$1`
        )
        .replace(/width="[^"]*"/, 'width="100vw"')
        .replace(/height="[^"]*"/, 'height="auto"');

      var htmlContent = "<div id='print-section'>" +
        "<div style='text-align: center; padding: 20px;' align='center'>" +
        "<h2>" + this.selectedPartName + "</h2>" +
        "</div>" +
        "<div style='text-align: center;'>" +
        svgWithAttrs
      "</div>" +
        "</div>";
      printJS({
        printable: htmlContent,
        type: 'raw-html',
        style: `
      @media print {
        html, body {
          margin: 0;
          padding: 0;
          width: 120vw;
        }
  
        h2 {
          text-align: center;
        }
  
        svg {
          width: 120vw !important;
          height: auto !important;
          display: block;
          margin: 0 auto;
        }
      }
    `,
      });
    }
  }

  nodeMouseOver(event): void {
    if (event.target) {
      const nodeId = event.target.id == "" ? 'node_' + event.target.innerHTML : event.target.id.replace('_content', '');
      const selectedNode = this.diagram.getObject(nodeId) as NodeModel;
      if (selectedNode) {
        var boothNo = selectedNode.id.replace('node_', '');
        var selectedBooth = this.allBooths.filter(e => e.BoothNumber == boothNo);
        this.BoothNumber = boothNo;
        this.BoothType = selectedBooth[0]?.BoothType;
      }
      else {
        this.BoothNumber = "";
        this.BoothType = "";
      }
    }
  }
}
